import type { IContactMessageResponse } from "./types";
import type { IPathBaseParam, IPathByIdParam } from "./path";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";
import { respond } from "@api/contactMessages/respond/api";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IContactMessageResponse>>,
  IPathBaseParam,
  IPaginationParams
>("contactMessages");
const getApis = createGetApi<
  IApiResponse<IContactMessageResponse>,
  IPathByIdParam,
  object
>("contactMessages");

export const contactMessages = {
  ...getAllApis,
  ...getApis,
  respond,
};
